<div class="apto-ionic-select"
     (click)="change($event)">
  <span class="apto-ionic-select--value"
        [ngClass]="{ 'apto-ionic-select--placeholder': !value }">
      {{ value || placeholder }}
  </span>
</div>
